import { render } from "./ChangesPass.vue?vue&type=template&id=d93056dc&scoped=true"
import script from "./ChangesPass.vue?vue&type=script&lang=js"
export * from "./ChangesPass.vue?vue&type=script&lang=js"

import "./ChangesPass.vue?vue&type=style&index=0&id=d93056dc&lang=css"
import "./ChangesPass.vue?vue&type=style&index=1&id=d93056dc&scoped=true&lang=css"

import exportComponent from "D:\\Shivani\\myProjects\\p2p_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d93056dc"]])

export default __exports__